import React from "react";

const Tos = () => {
  return (
    <div className="container grand_parent_div_text">
      <h2>Terms Of Use</h2>
      <p>
        If you choose to visit the Services, your visit and any dispute over
        privacy is subject to this Policy and our Terms of Use.
      </p>
      <h2>What are the intellectual property rights on the Platform?</h2>
      <h6>
        <b>Creator Rights</b>
      </h6>
      <p>
        The Creator owns all legal right, title, and interest in all
        intellectual property rights underlying the Digital Artwork minted by
        the Creator on the Platform, including but not limited to copyrights and
        trademarks. As the copyright owner, the Creator has the right to
        reproduce, prepare derivative Digital Artwork, distribute, and display
        or perform the Digital Artwork. Creators hereby acknowledges,
        understands, and agrees that selling a Digital Artwork on MMO NFT
        Marketplace constitutes an express representation, warranty, and
        covenant that the Creator has not, will not, and will not cause another
        to sell, tokenize, or create another cryptographic token representing a
        digital collectible for the same Digital Artwork. excepting, without
        limitation, the Creator’s ability to sell, tokenize, or create a
        cryptographic token or other digital asset representing a legal,
        economic, or other interest relating to any of the exclusive rights
        belonging to the Creator under copyright law. The Creator hereby
        acknowledges, understands, and agrees that launching a Digital Artwork
        on MMO NFT Marketplace constitutes an express and affirmative grant to
        MMO NFT Marketplace. its affiliates and successors a non-exclusive,
        world-wide, assignable, sub licensable, perpetual, and royalty-free
        license to make copies of, display, perform, reproduce, and distribute
        the Digital Artwork on any media whether now known or later discovered
        for the broad purpose of operating, promoting, sharing, developing,
        marketing, and advertising the Platform, or any other purpose related to
        MMO NFT Marketplace, including without limitation, the express right to:
        (i) display or perform the Digital Artwork on the Platform, a third
        party platform, social media posts, blogs, editorials, advertising,
        market reports, virtual galleries, museums, virtual environments,
        editorials, or to the public; (ii) create and distribute digital or
        physical derivative Digital Artwork based on the Digital Artwork; (iii)
        indexing the Digital Artwork in electronic databases, indexes,
        catalogues; and (iv) hosting, storing, distributing, and reproducing one
        or more copies of the Digital Artwork within a distributed file keeping
        system, node cluster, or other database (e.g., IPFS) or causing,
        directing, or soliciting others to do so. Creators expressly represent
        and warrant that their Digital Artwork listed on MMO NFT Marketplace
        contains only original content otherwise authorized for use by the
        Creator, and does not contain unlicensed or unauthorized copyrighted
        content, including any imagery, design, audio, video, human likeness, or
        other unoriginal content not created by the Creator, not authorized for
        use by the Creator, not in the public domain, or otherwise without a
        valid claim of fair use, the Creator further represents and warrants
        that it has permission to incorporate the unoriginal content.
      </p>
      <h6>
        <b>Collectors Rights</b>
      </h6>
      <p>
        Collectors receive a cryptographic token representing the Creator’s
        Digital Artwork as a piece of property, but do not own the creative work
        itself. Collectors may display and share the Digital Artwork, but
        Collectors do not have any legal ownership, right, or title to any
        copyrights, trademarks, or other intellectual property rights to the
        Digital Artwork, excepting the limited license to the Digital Artwork
        granted by these Terms. Upon collecting a Digital Artwork, Collectors
        receive a limited, worldwide, non-assignable, non-sublicensable,
        royalty-free license to display the Digital Artwork legally owned and
        properly obtained by the Collector. The Collector’s limited license to
        display the Digital Artwork, includes, but is not limited to, the right
        to display the Digital Artwork privately or publicly: (i) for the
        purpose of promoting or sharing the Collector’s purchase, ownership, or
        interest, (ii) for the purpose of sharing, promoting, discussing, or
        commenting on the Digital Artwork; (iii) on third party marketplaces,
        exchanges, platforms, or applications in association with an offer to
        sell, or trade, the Digital Artwork; and (iv) within decentralized
        virtual environments, virtual worlds, virtual galleries, virtual
        museums, or other navigable and perceivable virtual environments.
        Collectors have the right to sell, trade, transfer, or use their Digital
        Artwork, but Collectors may not make “commercial use” of the Digital
        Artwork. The Collector agrees that it may not, nor permit any third
        party, to do or attempt to do any of the foregoing without the Creator’s
        express prior written consent in each case: (i) modify, distort,
        mutilate, or perform any other modification to the Work which would be
        prejudicial to the Creator’s honor or reputation; (ii) use the Digital
        Artwork to advertise, market, or sell any third party product or
        service; (iii) use the Digital Artwork in connection with images,
        videos, or other forms of media that depict hatred, intolerance,
        violence, cruelty, or anything else that could reasonably be found to
        constitute hate speech or otherwise infringe upon the rights of others;
        (iv) incorporate the Digital Artwork in movies, videos, video games, or
        any other forms of media for a commercial purpose, except to the limited
        extent that such use is expressly permitted by these Terms or solely for
        your Collector’s personal, non-commercial use; (v) sell, distribute for
        commercial gain, or otherwise commercialize merchandise that includes,
        contains, or consists of the Digital Artwork; (vi) attempt to trademark,
        copyright, or otherwise acquire additional intellectual property rights
        in or to the Digital Artwork; (vii) attempt to mint, tokenize, or create
        an additional cryptographic token representing the same Digital Artwork,
        whether on or off of the MMO NFT Marketplace Platform; (viii) falsify,
        misrepresent, or conceal the authorship of the Digital Artwork; or (ix)
        otherwise utilize the Digital Artwork for the Collector’s or any third
        party’s commercial benefit.
      </p>
      <p>
        Platform Content, Software and Trademarks: You acknowledge and agree
        that the Platform may contain content or features (“Platform Content”)
        that are protected by copyright, patent, trademark, trade secret or
        other proprietary rights and laws. Except as expressly authorized by MMO
        NFT Marketplace, you agree not to modify, copy, frame, scrape, rent,
        lease, loan, sell, distribute or create derivative works based on the
        Platform or the Platform Content, in whole or in part. In connection
        with your use of the Platform you will not engage in or use any data
        mining, robots, scraping or similar data gathering or extraction
        methods. If you are blocked by MMO NFT Marketplace from accessing the
        Platform (including by blocking your IP address), you agree not to
        implement any measures to circumvent such blocking (e.g., by masking
        your IP address or using a proxy IP address). Any use of the Platform or
        the Platform Content other than as specifically authorized herein is
        strictly prohibited.
      </p>
      <p>
        The technology and software underlying the Platform or distributed in
        connection therewith are the property of MMO NFT Marketplace, our
        affiliates and our partners (the “Software”). You agree not to copy,
        modify, create a derivative work of, reverse engineer, reverse assemble
        or otherwise attempt to discover any source code, sell, assign,
        sublicense, or otherwise transfer any right in the Software. Any rights
        not expressly granted herein are reserved by MMO NFT Marketplace.
      </p>
      <p>
        Third Party Material: Under no circumstances will MMO NFT Marketplace be
        liable in any way for any content or materials of any third parties
        (including users), including, but not limited to, for any errors or
        omissions in any content, or for any loss or damage of any kind incurred
        as a result of the use of any such content. User Content Transmitted
        Through the Platform: With respect to the content, Digital Artwork, or
        other materials you upload through the Platform or share with other
        users or recipients (collectively, “User Content”), you represent and
        warrant that you own all right, title and interest in and to such User
        Content, including, without limitation, all copyrights and rights of
        publicity contained therein. By uploading any User Content you hereby
        grant and will grant MMO NFT Marketplace and its affiliated companies a
        nonexclusive, worldwide, royalty free, fully paid up, transferable,
        sublicensable, perpetual, irrevocable license to copy, display, upload,
        perform, distribute, store, modify and otherwise use your User Content
        in connection with the operation of the Platform or the promotion,
        advertising or marketing thereof in any form, medium or technology now
        known or later developed. Any questions, comments, suggestions, ideas,
        feedback or other information about the Platform (“Submissions”),
        provided by you to MMO NFT Marketplace are non-confidential and MMO NFT
        Marketplace will be entitled to the unrestricted use and dissemination
        of these Submissions for any purpose, commercial or otherwise, without
        acknowledgment or compensation to you. MMO NFT Marketplace may preserve
        content and may also disclose content if required to do so by law or in
        the good faith belief that such preservation or disclosure is reasonably
        necessary to: (a) comply with legal process, applicable laws or
        government requests; (b) enforce these Terms of Service; (c) respond to
        claims that any content violates the rights of third parties; or (d)
        protect the rights, property, or personal safety of MMO NFT Marketplace,
        its users and the public. You understand that the technical processing
        and transmission of the Platform, including your content, may involve
        (a) transmissions over various networks; and (b) changes to conform and
        adapt to technical requirements of connecting networks or devices.
        Copyright Complaints: MMO NFT Marketplace respects the intellectual
        property of others, and we ask our users to do the same. MMO NFT
        Marketplace will process and investigate notices of alleged infringement
        and will take appropriate actions under the Digital Millennium Copyright
        Act (“DMCA”) and other applicable intellectual property laws with
        respect to any alleged or actual infringement. To be effective, the
        notification must be in writing and contain the following information:
      </p>
    </div>
  );
};

export default Tos;
